module.exports = __webpack_public_path__ + "static/rituals-eabcb93dc06fbb29a1ba5872ec454003.png";